import React from "react";
import "../EventGallery.css";

const Daytwo2023 = () => {
  const images = [
    "https://cloud.hoverbusinessservices.com/aiifa/media/past-events/2023/day2-2023/1.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/2.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/3.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/4.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/5.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/6.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/7.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/8.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/9.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/10.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/11.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/12.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/13.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/14.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/15.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/16.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/17.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/18.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/19.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/20.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/21.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/22.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/23.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/24.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/25.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/26.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/27.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/28.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/29.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/30.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/31.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/32.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/33.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/34.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/35.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/36.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/37.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/38.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/39.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/40.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day2-2023/41.jpg",
    
  ];

  return (
    <div className="event-gallery-container">
      <h2 className="event-gallery-title">Event 2023 Day 2</h2>
      <div className="event-gallery-grid">
        {images.map((img, index) => (
          <div key={index} className="event-gallery-card">
            <img src={img} alt={`Event ${index + 1}`} />
          </div> 
        ))}
      </div>
    </div>
  );
};

export default Daytwo2023;